import { Tooltip, Typography, Box } from "@mui/material";
import { EvaluationType } from "../../../interface";
import { getTotalEvaluationCount } from "../../../utils/helper";

const Legend = ({
  legendText,
  legendIcon,
  legendIconColor,
}: {
  legendText: string;
  legendIcon: string;
  legendIconColor: string;
}) => {
  return (
    <Box className="evaluation-legend">
      <Box
        component="span"
        className={`evaluation-legend-icon evaluation-legend-icon--${legendIconColor}`}
      >
        {legendIcon}
      </Box>
      {legendText}
    </Box>
  );
};

const TooltipContent = ({ data }: { data: EvaluationType }) => {
  return (
    <Box
      className="evaluation-tooltip-container"
      data-testid="evaluation-tooltip-container"
    >
      <Legend legendText="Pass" legendIcon="●" legendIconColor="green" />
      <Legend legendText="Fail" legendIcon="●" legendIconColor="red" />
      {/*
      OUT OF SCOPE
      <Legend
        legendText="Needs Evaluation"
        legendIcon="▲"
        legendIconColor="yellow"
      /> */}
      <Box className="evaluation-value">
        {["AE", "SS", "HC", "PC"].map((key) => (
          <Box key={key} className="evaluation-value-item">
            <Typography variant="body2">{key}</Typography>
            <Typography className="value" variant="body2" ml={2}>
              <Box component="span" className="evaluation-legend-icon--green">
                ●
              </Box>{" "}
              {(data?.pass && data?.pass[key as "AE" | "SS" | "HC" | "PC"]) ||
                0}
              <Box
                component="span"
                className="evaluation-legend-icon--red"
                ml={1}
              >
                ●
              </Box>{" "}
              {(data?.fail && data?.fail[key as "AE" | "SS" | "HC" | "PC"]) ||
                0}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const CustomEvaluationValue = ({ data }: { data: EvaluationType }) => {
  return (
    <Tooltip title={<TooltipContent data={data} />} arrow>
      <Box className="evaluation-container">
        <Typography variant="body2" className="evaluation-pass">
          {getTotalEvaluationCount(data?.pass)}
        </Typography>
        <Typography variant="body2" className="evaluation-fail" ml={3}>
          {getTotalEvaluationCount(data?.fail)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default CustomEvaluationValue;
